// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".component-body-row-icon {\n  position: absolute;\n  top: -2px;\n  left: 51%;\n  font-size: 19px;\n}\n\n.component-body-row-text {\n  color: #f9f900;\n  display: contents;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
